import React from 'react';
import styled from 'astroturf/react';

export interface Props {
  imageUrls: [string, string, string];
}

const Container = styled.div`
  width: 798px;
  height: 415px;
  background: center / contain no-repeat url(/images/courses/empty-player.svg);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Image = styled.img`
  width: 256px;
  height: 256px;
  object-fit: cover;
`;

const ThreeImages: React.FunctionComponent<Props> = ({ imageUrls }) => {
  const images = imageUrls.map((url, index) => (
    <Image
      key={index}
      alt={`Topic thumbnail ${index + 1}`}
      src={url}
      width={256}
      height={256}
    />
  ));
  return <Container>{images}</Container>;
};

export default ThreeImages;
